let { hostname} = window.location;
let AppInfo = {};
let INFO = {
    imgage:'https://cdn.bzxd.tv/mydemo/demoimg1.png',
    imgage_1:'https://cdn.bzxd.tv/mydemo/demoimg1-1.png',
    icp:'蜀ICP备2021003210号-4',
    appdown:'https://cdn.ryruyue.com/app/ruyue_official.apk',
    appname:'不止心动（成都）网络科技有限公司',
    address:'',
    Mail:'hnndkf@163.com'
    
}
console.log(hostname,hostname.match('bzxd.top'));
if(hostname.match("ryruyue")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg1.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg1-1.png'
    INFO.appdown='https://cdn.ryruyue.com/app/ruyue_official.apk'
  }
  if(hostname.match("mxmixin")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg2-1.png'
    INFO.appdown='https://cdn.bzxd.tv/mx/mixin_official.apk'
    INFO.icp='蜀ICP备2021003210号-3'
    INFO.recordcode='沪公网安备31011502019985号'
  }
  // mymeiyue
  if(hostname.match("mymeiyue")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg3.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg3-1.png'
    INFO.icp='蜀ICP备2021003210号-7'
    INFO.appdown='https://cdn.bzxd.tv/my/meiyue_official.apk'
  }
  //mixinmixin
  if(hostname.match("mixinmixin")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg4.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg4-1.png'
    INFO.icp='蜀ICP备2021003210号-5'
    INFO.appdown='https://cdn.mixinmixin.com/app/mixin2_official.apk'
  }
  //mmmoyan
  if(hostname.match("mmmoyan")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg5.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg5-1.png'
    INFO.icp='蜀ICP备2021003210号-6'
    INFO.appdown='https://cdn.mmmoyan.com/moyan/moyan_official.apk'

  }
  if(hostname.match('bzxd.top')){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg6.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg6-1.png'
    INFO.icp='蜀ICP备2021003210号-12'
    INFO.appdown='https://cdn.ryruyue.com/distinguished/jiaren_official.apk'
  }
  //yqyunqing.cn
  if(hostname.match("yqyunqing")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg7.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg7-1.png'
    INFO.icp='蜀ICP备2021003210号-22'
    INFO.appdown='https://cdn.yqyunqing.cn/yunqing/yunqing_official.apk'

  }
  //fhfenghua.cn
  if(hostname.match("fhfenghua")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg8.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg8-1.png'
    INFO.icp='蜀ICP备2021003210号-21'
    INFO.appdown='https://cdn.fhfenghua.cn/fh/fenghua_official.apk'

  }
  //qyqiaoyuan.cn
  if(hostname.match("qyqiaoyuan")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg9.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg9-1.png'
    INFO.icp='蜀ICP备2021003210号-15'
    INFO.appdown='https://cdn.qyqiaoyuan.cn/app/qy/qiaoyuan_official.apk'
  }
  //haohehaohe.cn
  if(hostname.match("haohehaohe")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg10.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg10-1.png'
    INFO.icp='蜀ICP备2021003210号-20'
    INFO.appdown='https://cdn.haohehaohe.cn/haohe/haohe_official.apk'

  }
  //cdchengdui.cn
  if(hostname.match("cdchengdui")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg11.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg11-1.png'
    INFO.icp='蜀ICP备2021003210号-19'
    INFO.appdown='https://cdn.cdchengdui.cn/cd/chengdui_official.apk'
  }
  // jiubanapp
  if(hostname.match("jiubanapp")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg12.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg12-1.png'
    INFO.icp='琼ICP备2024019521号-1'
    INFO.appname='海南豪旺网络科技有限公司'
    INFO.appdown='https://cdn.jiubanapp.com/app/jiuban/jiuban_official.apk'

    // 海南豪旺网络科技有限公司
  }

//huanyuanapp
  if(hostname.match("huanyuanapp")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg13.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg13-1.png'
    INFO.icp='琼ICP备2024018839号-2'
    INFO.appname='海南满乐游网络科技有限公司'
    INFO.appdown='https://cdn.huanyuanapp.cn/hyapp/huanyuan_official.apk'
  }

//youyuanonline.cn
if(hostname.match("youyuanonline")){
  INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg14.png'
  INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg14-1.png'
  INFO.icp='琼ICP备2024018839号-1'
  INFO.appname='海南满乐游网络科技有限公司'

}
// hnzhengqiang.cn
if(hostname.match("hnzhengqiang.cn")){
  INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg15.png'
  INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg15-1.png'
  INFO.icp='琼ICP备2024016412号-1'
  INFO.appname='海南正强网络科技有限公司'
}
if(hostname.match("hehuanapp.cn")){
  INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg16.png'
  INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg16-1.png'
  INFO.icp='琼ICP备2024016412号-3'
  INFO.appname='海南正强网络科技有限公司'
  
}
if(hostname.match("huanyueapp.cn")){
  INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg17.png'
  INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg17-1.png'
  INFO.icp='琼ICP备2024016412号-2'
  INFO.appname='海南正强网络科技有限公司'
}
if(hostname.match("ruyuanapp.cn")){
  INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg18.png'
  INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg18-1.png'
  INFO.icp='琼ICP备17005324号-16'
  INFO.appname='海南尼豆网络科技有限公司'
  INFO.appdown='https://cdn.ruyuanapp.cn/ruyuan/ruyuan_official.apk'
}
if(hostname.match("jiuyuanapp.cn")){
  INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg19.png'
  INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg19-1.png'
  INFO.icp='琼ICP备17005324号-17'
  INFO.appname='海南尼豆网络科技有限公司'
  INFO.appdown='https://cdn.jiubanapp.com/app/jiuban/jiuban_official.apk'
}
if(hostname.match("qtqingtou.cn")){
  INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg20.png'
  INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg20-1.png'
  INFO.icp='琼ICP备2024019521号-6'
  INFO.appname='海南豪旺网络科技有限公司'
  INFO.appdown='https://cdn.jiubanapp.com/app/jiuban/jiuban_official.apk'
}

  //cschengshuang.cn
  if(hostname.match("cschengshuang")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg21.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg21-1.png'
    INFO.icp='蜀ICP备2021003210号-26'
    INFO.appdown='https://cdn.cschengshuang.cn/cs/chengshuang_official.apk'
  }

    //qingxinliaoqx.cn
  if(hostname.match("qingxinliaoqx")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg22.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg22-1.png'
    INFO.icp='琼ICP备2024019521号-5'
    INFO.appdown='https://cdn.qingxinliaoqx.cn/qxl/qingxinliao_official.apk'
    INFO.appname='海南豪旺网络科技有限公司'

  }

      //xinxinliao.cn
      if(hostname.match("xinxinliao")){
        INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg23.png'
        INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg23-1.png'
        INFO.icp='琼ICP备2024019521号-7'
        INFO.appdown=''
        INFO.appname='海南豪旺网络科技有限公司'

      }
       //changyuanapp.cn
  if(hostname.match("changyuanapp")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg24.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg24-1.png'
    INFO.icp='沪ICP备2023021267号-10'
    INFO.appdown=''
    INFO.appname='上海璟栝网络科技有限公司'

  }
  //qingqianapp.cn
  if(hostname.match("qingqianapp")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg25.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg25-1.png'
    INFO.icp='沪ICP备2023021267号-9'
    INFO.appdown=''
    INFO.appname='上海璟栝网络科技有限公司'

  }
  //ylyulian.cn
  if(hostname.match("ylyulian")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg30.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg30-1.png'
    INFO.icp='沪ICP备2023021267号-11'
    INFO.appdown=''
    INFO.appname='上海璟栝网络科技有限公司'

  }
  //yuanquapp.cn
  if(hostname.match("yuanquapp")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg27_2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg27_2-1.png'
    INFO.icp='沪ICP备2023021267号-7'
    INFO.appdown='https://cdn.yuanquapp.cn/yuanqu/yuanqu_official.apk'
    INFO.appname='上海璟栝网络科技有限公司'

  }
  //dayliao.cn
  if(hostname.match("dayliao")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg28.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg28-1.png'
    INFO.icp='琼ICP备2024019521号-3'
    INFO.appdown='https://cdn.dayliao.cn/tiantianliao/tiantianliao_official.apk'
    INFO.appname='海南豪旺网络科技有限公司'

  }
  //joyliao.cn
  if(hostname.match("joyliao")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg29.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg29-1.png'
    INFO.icp='琼ICP备2024019521号-4'
    INFO.appdown='https://cdn.joyliao.cn/app/liaohuan/liaohuan_official.apk'
    INFO.appname='海南豪旺网络科技有限公司'

  }
  //yuyuanyy.cn
  if(hostname.match("yuyuanyy")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg26.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg26-1.png'
    INFO.icp='沪ICP备2023021267号-8'
    INFO.appdown='https://cdn.yuyuanyy.cn/yuyuan/yuyuan_official.apk'
    INFO.appname='上海璟栝网络科技有限公司'
  }

  //yiqiwanban.cn 
  if(hostname.match("yiqiwanban")){
    // INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg31.png'
    // INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg31-1.png'
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg32_2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg32_2-1.png'
    INFO.imgage_2 = 'https://cdn.bzxd.tv/mydemo/demoimg32_2-2.png'
    INFO.icp='沪ICP备2024074023号-3'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335234号'
    INFO.appname='上海启豆网络科技有限公司'
  }
  
  //wanmeiwanban.cn 
  if(hostname=="wanmeiwanban.cn"){
    // INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg32_2.png'
    // INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg32_2-1.png'
    // INFO.imgage_2 = 'https://cdn.bzxd.tv/mydemo/demoimg32_2-2.png'
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/wmimg.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/wmimg_1.png'
    INFO.imgage_2 = 'https://cdn.bzxd.tv/mydemo/wmimg_2.png'
    INFO.icp='沪ICP备2024074023号-2'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335223号'
    INFO.appname='上海启豆网络科技有限公司'
  }

  //wanmeidazi.com
  if(hostname.match("wanmeidazi.com")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/wmimg.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/wmimg_1.png'
    INFO.imgage_2 = 'https://cdn.bzxd.tv/mydemo/wmimg_2.png'
    INFO.icp='沪ICP备2024074023号-6'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335222号'
    INFO.appname='上海启豆网络科技有限公司'
  }

  //home.wanmeiwanban.cn
  if(hostname.match("home.wanmeiwanban.cn")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg32_2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg32_2-1.png'
    INFO.imgage_2 = 'https://cdn.bzxd.tv/mydemo/demoimg32_2-2.png'
    INFO.icp='琼ICP备2024074023号-2'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335223号'
    INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='海南尼豆网络科技有限公司'
  }

  //langmanmanwuapp.cn
  if(hostname.match("langmanmanwuapp")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg33.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg33-1.png'
    INFO.icp='琼ICP备17005324号-24'
    INFO.appdown='https://cdn.langmanmanwuapp.cn/lmmw/langman_official.apk'
    INFO.recordcode='沪公网安备31010402335229号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='海南尼豆网络科技有限公司'
  }

  //yuanfensupeiwu.cn
  if(hostname.match("yuanfensupeiwu")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg34.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg34-1.png'
    INFO.icp='琼ICP备17005324号-21'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335228号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='海南尼豆网络科技有限公司'
  }

  //suixinyuyou.cn
  if(hostname.match("suixinyuyou")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg35_2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg35_2-1.png'
    INFO.icp='琼ICP备17005324号-20'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335226号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='海南尼豆网络科技有限公司'
  }

  //xinyumiban.cn
  if(hostname.match("xinyumiban")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg36.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg36-1.png'
    INFO.icp='琼ICP备17005324号-22'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335230号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='海南尼豆网络科技有限公司'
  }

  //yuanfenriji.cn
  if(hostname.match("yuanfenriji")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg37.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg37-1.png'
    INFO.icp='琼ICP备17005324号-23'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335227号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='海南尼豆网络科技有限公司'
  }

//linghunxiehou.cn
    if(hostname.match("linghunxiehou")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg38_2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg38_2-1.png'
    INFO.icp='沪ICP备2023015359号-7'
    INFO.appdown='https://cdn.linghunxiehou.cn/soul/soul_official.apk'
    INFO.recordcode='沪公网安备31010402335389号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='上海薄客网络科技有限公司'
  }

  //xintiaoxiehou.cn
    if(hostname.match("xintiaoxiehou")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg39_2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg39_2-1.png'
    INFO.icp='沪ICP备2023015359号-8'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335387号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='上海薄客网络科技有限公司'
  }

  //xianwaizhiyin.cn
    if(hostname.match("xianwaizhiyin")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg40_2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg40_2-1.png'
    INFO.icp='沪ICP备2023015359号-9'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335391号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='上海薄客网络科技有限公司'
  }

  //miyuhuisheng.cn
    if(hostname.match("miyuhuisheng")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg41.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg41-1.png'
    INFO.icp='沪ICP备2023015359号-5'
    INFO.appdown='https://cdn.miyuhuisheng.cn/myhs/miyuhuisheng_official.apk'
    INFO.recordcode='沪公网安备31010402335388号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='上海薄客网络科技有限公司'
  }

  //xinyuxinyuan.com.cn
    if(hostname.match("xinyuxinyuan")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg42_2.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg42_2-1.png'
    INFO.icp='沪ICP备2023015359号-6'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335390号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='上海薄客网络科技有限公司'
  }
  //hanqingmomoapp.cn
  if(hostname.match("hanqingmomoapp")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg43.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg43-1.png'
    INFO.icp='沪ICP备2023021267号-12'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335525号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='上海璟栝网络科技有限公司'
  }
  //hongdouxiangsi.cn
  if(hostname.match("hongdouxiangsi")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg44.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg44-1.png'
    INFO.icp='沪ICP备2023021267号-13'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335526号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='上海璟栝网络科技有限公司'
  }
  //xiusekeren.cn
  if(hostname.match("xiusekeren")){
    INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg45.png'
    INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg45-1.png'
    INFO.icp='沪ICP备2023021267号-14'
    INFO.appdown=''
    INFO.recordcode='沪公网安备31010402335536号'
    // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
    INFO.appname='上海璟栝网络科技有限公司'
  }

    //shbokewl.cn 玩趣星球
    if(hostname.match("shbokewl")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/wqxq_banner1.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/wqxq_banner2.png'
      INFO.icp='沪ICP备2023015359号-2'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402335723号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海薄客网络科技有限公司'
    }
    //qingtouyihe.cn 情投意合
    if(hostname.match("qingtouyihe")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg46.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg46-1.png'
      INFO.icp='沪ICP备2023021267号-20'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402335717号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海璟栝网络科技有限公司'
    }
    //fengqingyueyi.cn 风情月意
    if(hostname.match("fengqingyueyi")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg47.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg47-1.png'
      INFO.icp='沪ICP备2023021267号-21'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402335718号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海璟栝网络科技有限公司'
    }
    //linyuanapp.cn 附近邻缘交友
    if(hostname.match("linyuanapp")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg48.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg48-1.png'
      INFO.icp='沪ICP备2023021267号-23'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402335715号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海璟栝网络科技有限公司'
    }
    //zhiyinchat.cn 知音引力
    if(hostname.match("zhiyinchat")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg49.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg49-1.png'
      INFO.icp='沪ICP备2023021267号-22'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402335716号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海璟栝网络科技有限公司'
    }
    //qingyimianmian.cn 情意绵绵
    if(hostname.match("qingyimianmian")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg50.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg50-1.png'
      INFO.icp='沪ICP备2023015359号-15'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402335722号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海薄客网络科技有限公司'
    }
    //rujiaosiqi.cn 如胶似漆
    if(hostname.match("rujiaosiqi")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg51.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg51-1.png'
      INFO.icp='沪ICP备2023015359号-16'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402335721号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海薄客网络科技有限公司'
    }
    //yulianchat.cn 同城语恋聊天
    if(hostname.match("yulianchat")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg52.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg52-1.png'
      INFO.icp='沪ICP备2023015359号-17'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402335720号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海薄客网络科技有限公司'
    }
//     新马甲：你偶（如约马甲包）
// 你偶包名：com.love.spouselove
// niouapp.cn
    if(hostname.match("niouapp")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg53.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg53-1.png'
      INFO.icp='沪ICP备2024074023号-9'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402336084号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海启豆网络科技有限公司'
    }
    // 新马甲：别样爱（她聊马甲包）
    // 包名：com.bieyang.love
    // bieyangai.cn
    if(hostname.match("bieyangai")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg54.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg54-1.png'
      INFO.icp='沪ICP备2024074023号-10'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402336085号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海启豆网络科技有限公司'
    }
      // 新马甲包语恋（她聊马甲包）
    // 包名：com.bieyang.love
    // bieyangai.cn
    if(hostname.match("bieyangai")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg55.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg55-1.png'
      INFO.icp='沪ICP备2024074023号-10'
      INFO.appdown=''
      INFO.recordcode='沪公网安备31010402336085号'
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海启豆网络科技有限公司'
    }
    // yffzapp.cn缘分方舟
    if(hostname.match("yffzapp")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg56.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg56-1.png'
      INFO.icp='沪ICP备2024074023号-14'
      INFO.appdown=''
      INFO.recordcode=''
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海启豆网络科技有限公司'
    }
// shxfapp.cn山海相逢
    if(hostname.match("shxfapp")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg57.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg57-1.png'
      INFO.icp='沪ICP备2024074023号-13'
      INFO.appdown=''
      INFO.recordcode=''
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海启豆网络科技有限公司'
    }
    // shanghaibotui.cn
    if(hostname.match("shanghaibotui.cn")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg58_1.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg58-1.png'
      INFO.icp='沪ICP备2026018688号-1'
      INFO.appdown=''
      INFO.recordcode=''
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海博推网络科技有限公司'
      INFO.Mail='zackincrazy@hotmail.com'
    }
    // hkqianlikeji.com.cn
    if(hostname.match("hkqianlikeji.com.cn")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg58_1.png'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg58-2.png'
      INFO.icp=''
      INFO.appdown=''
      INFO.recordcode=''
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='香港千里科技有限公司'
      INFO.Mail='zackincrazy@hotmail.com'
    }
    // https://shanghaiyixuan.com.cn/
    if(hostname.match("shanghaiyixuan.com.cn")){
      INFO.imgage = 'https://cdn.bzxd.tv/mydemo/demoimg62.jpg'
      INFO.imgage_1 = 'https://cdn.bzxd.tv/mydemo/demoimg62-1.jpg'
      INFO.imgage_2 = 'https://cdn.bzxd.tv/mydemo/demoimg62-2.jpg'
      INFO.icp='沪ICP备2026024118号-1'
      INFO.appdown=''
      INFO.recordcode=''
      // INFO.address='公司地址：海南省澄迈县老城高新技术产业示范区海南生态软件园A17幢一层3001'
      INFO.appname='上海佚轩网络科技有限公司'
      INFO.Mail='xintianwang@shanghaiyixuan.com.cn'
    }

  AppInfo = { ...INFO }; 

export { AppInfo };